import {Injectable} from '@angular/core';


import authInfoJSON from '@mock/api/authInfo.mock.json';

import tenantJSON from '@mock/api/tenant.mock.json';
import tenantDetailsJSON from '@mock/api/tenant-details.mock.json';

import tenantsCommunityTotalsJSON from '@mock/api/tenants-community-totals.mock.json';
import tenantsCommunityDatasJSON from '@mock/api/tenants-community-datas.mock.json';


import customerEnergyUsagesJSON from '@mock/api/customers-energy-usages.mock.json';
import customerEnergyDatasJSON from '@mock/api/customers-energy-datas.mock.json';

import tenantsCustomerProductionsites from '@mock/api/tenants-customers-productionsites.mock.json';
import {BackendHttpInterceptor} from '@mock/backend-http.interceptor';
import {RspEndpointsService} from '@rsp/shared/services/rest/rsp-endpoints.service';

@Injectable()
export class RspHttpInterceptor extends BackendHttpInterceptor {
  protected mockCall(endpointPath: string, params: string[][]): any {
    switch (endpointPath) {

      case 'auth/energy-sales-regionalplatform/authinfo':
        return authInfoJSON;

      case RspEndpointsService.TENANTS_COMMUNITY_DATA:
        return tenantsCommunityDatasJSON;

      case RspEndpointsService.TENANTS_COMMUNITY_TOTAL:
        return tenantsCommunityTotalsJSON;

      case RspEndpointsService.CUSTOMER_ENERGY_USAGE:
        return customerEnergyUsagesJSON;

      case RspEndpointsService.CUSTOMER_ENERGY_DATA:
        return customerEnergyDatasJSON;

      case RspEndpointsService.TENANTS_CUSTOMER_PRODUCTION_SITES:
        return tenantsCustomerProductionsites;
    }

    if (endpointPath.startsWith('tenant/')) {
      const pathChunks = endpointPath.split('/');

      if (pathChunks.length >= 3 && pathChunks[2] === RspEndpointsService.TENANT_DETAILS) {
        return tenantDetailsJSON;
      } else if (pathChunks.length >= 2) {
        return tenantJSON;
      }
    }

    return {};
  }
}
